import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import modalPromo from "../../images/carrusel/modal-promo.jpg";

function ModalCarrusel() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button variant="" className="button--gold" onClick={handleShow}>
        Descubre M&aacute;s
      </Button>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body>
          <img src={modalPromo} className="img-fluid" />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="" className="button--gold" onClick={handleClose}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalCarrusel;
